import styled from 'styled-components';
import { EspAccount } from 'modules/graphql/types';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { Body2, body2Bold } from 'ui/theme';
import { SET_DEFAULT_SENDER_TEXT } from '../../../../constants';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../../contexts';
import { useUpdateAccount } from '../../../../hooks';
import { EditEspAccountPayload } from '../../../../types';

export const TEXT = {
  ID: 'set-default-account-modal',
};

const Strong = styled.span`
  ${body2Bold}
`;

type Props = {
  espAccountId: number;
};

export const SetDefaultSenderModal = ({ espAccountId }: Props) => {
  const { hideModal } = useModalsContext();
  const { selectEspAccount, selectDefaultSender } = useSendingPlatformsQueryContext();
  const { isLoading, updateAccount } = useUpdateAccount();

  const espAccount = selectEspAccount(espAccountId);
  const defaultSender = selectDefaultSender();

  if (!espAccount) return null;

  const onSubmit = () => {
    const { id, name, esp, truncatedApiKey } = espAccount as EspAccount;
    const payload: EditEspAccountPayload = {
      id,
      name,
      esp,
      apiKey: truncatedApiKey,
      isDefault: true,
      editApiKey: false,
    };
    updateAccount(payload);
    hideModal();
  };

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{SET_DEFAULT_SENDER_TEXT}?</ModalHeader>
      <ModalBody>
        {defaultSender ? (
          <>
            <Body2>
              This will change your current default from <Strong>{defaultSender.name}</Strong> to{' '}
              <Strong>{espAccount.name}</Strong>.
            </Body2>
            <Body2>
              Message channels that aren’t bound to a specific sending platform will use this
              account to send messages by default. You can always change the sending account when
              you are creating a new message.
            </Body2>
          </>
        ) : (
          <>
            <Body2>
              Message channels that aren’t bound to a specific sending platform will use{' '}
              <Strong>{espAccount.name}</Strong> to send messages by default. You can always change
              the sending account when you are creating a new message.
            </Body2>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <PrimaryButton isLoading={isLoading} onClick={onSubmit} size={BUTTON_SIZES.LARGE}>
          {SET_DEFAULT_SENDER_TEXT}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
